var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-wrapper"},[_c('Header'),(_vm.navHeader)?_c('Nav'):_vm._e(),_c('router-view',{staticClass:"layout-content-container"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }